import { render, staticRenderFns } from "./CaseNotificationItem.vue?vue&type=template&id=2b6a6418"
import script from "./CaseNotificationItem.vue?vue&type=script&lang=js"
export * from "./CaseNotificationItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports